/**
 * El nivel del usuario logueado sobre el panel de **Operadores del Store** de UN store:
 * `store_operators` (xcons-docs#537), que vale `admin`, `viewer` o `no_access`.
 *
 * - `admin` administra: ve el listado y el detalle, guarda, agrega y quita operadores.
 * - `viewer` entra a las dos pantallas y no puede cambiar nada.
 * - `no_access` no ve la sección en el menú del store.
 *
 * Sale de la sesión, que se congela al login: un cambio se ve al volver a loguearse. **Una sesión
 * anterior al deploy no trae el code**: ahí vale lo que traía `store_permission`, que entonces
 * regía el panel (Editor como Lector), y sin eso lo que valdría sin fila, `admin`, siempre que el
 * usuario pertenezca al store —aparece en algún bucket de tipo Store—. Es la misma regla que aplica
 * la API en `nivelParaAdministrarOperadores`, así que el menú y el gate contestan lo mismo.
 */
export type NivelDeOperadores = "admin" | "viewer" | "no_access";

const normalizar = (valor: unknown): NivelDeOperadores | undefined => {
  const nivel = String(valor ?? "")
    .trim()
    .toLowerCase();
  if (nivel === "admin") return "admin";
  if (nivel === "viewer" || nivel === "editor") return "viewer";
  if (nivel === "no_access") return "no_access";
  return undefined;
};

export const nivelDeOperadores = (
  identity: any,
  storeCode: string,
): NivelDeOperadores => {
  const buckets: Record<string, Record<string, string> | undefined> =
    identity?.permissions?.store ?? {};
  const bucket = buckets.store_operators;
  if (bucket === undefined) {
    const viejo = normalizar(buckets.store_permission?.[storeCode]);
    if (viejo) return viejo;
    const pertenece = Object.values(buckets).some(
      (b) => !!b && Object.prototype.hasOwnProperty.call(b, storeCode),
    );
    return pertenece ? "admin" : "no_access";
  }
  const nivel = normalizar(bucket?.[storeCode]);
  return nivel === "admin" || nivel === "viewer" ? nivel : "no_access";
};
